/*
 * Copyright 2024 The Kokabo Authors. All rights reserved.
 * Use of this source code is governed by a BSD-style
 * license that can be found in the LICENSE file.
 */

const TimeoutForOnce = 60 * 1000;// Default RPC timeout (ms); long enough for slow networks, short enough to avoid hanging callers indefinitely.
const UnLimited = 100 * 365 * 24 * 60 * 60 * 1000;// Practical "no limit" sentinel; avoids Infinity semantics across JSON/serialization boundaries.
const Once = 1;

const CallInstruction = "c"
const AnswerInstruction = "a"
const ErrorInstruction = "e"

export {TimeoutForOnce, UnLimited,Once, CallInstruction, AnswerInstruction, ErrorInstruction}